var React = require('react');

function ExclamationDiamond (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.692 7.253c.41.412.41 1.082 0 1.492l-6.946 6.948c-.41.41-1.082.41-1.492 0L.308 8.745a1.057 1.057 0 0 1 0-1.493L7.254.308c.41-.41 1.082-.41 1.492 0l6.946 6.946zM8.5 12.5c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1zm.065-3c.268 0 .52-.249.507-.5l.175-5c.032-.299-.203-.5-.472-.5h-1.55a.48.48 0 0 0-.475.5l.148 5c.008.275.235.5.504.5h1.163z"}));
}

ExclamationDiamond.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ExclamationDiamond;

ExclamationDiamond.default = ExclamationDiamond;
